
export class LogoManager {
  private container: HTMLElement;
  private urlResolver: any; // Using any temporarily for the refactor
  private logoElement: HTMLImageElement | null = null;
  
  constructor(container: HTMLElement, urlResolver: any) {
    this.container = container;
    this.urlResolver = urlResolver;
  }
  
  addLogo(): void {
    try {
      console.log('[DEBUG] Adding logo to component container');
      
      const logoContainer = document.createElement('div');
      logoContainer.className = 'onexip-logo-container';
      
      const logoOptions = [
        "lovable-uploads/834b5736-c59b-4cee-961c-1d5687a820fd.png",
        "https://www.onexip.com/wp-content/uploads/2023/10/onexip-logo.png",
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgNTAiPjx0ZXh0IHg9IjEwIiB5PSIzMCIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNGOTczMTYiPm9uZXhpcDwvdGV4dD48L3N2Zz4="
      ];
      
      const logo = document.createElement('img');
      logo.className = "onexip-logo";
      logo.alt = "onexip Logo";
      logo.style.cssText = "height: 2.5rem; display: block; max-width: 100%;";
      this.logoElement = logo;
      
      // Try to preload all logo options to determine which one works
      this.preloadLogoOptions(logoOptions, logo, logoContainer);
      
      logoContainer.appendChild(logo);
      this.container.appendChild(logoContainer);
      console.log('[DEBUG] Logo container added to DOM');
    } catch (error) {
      console.error('[ERROR] Error adding logo:', error);
      this.createTextFallback(this.container);
    }
  }
  
  private preloadLogoOptions(options: string[], logoElement: HTMLImageElement, container: HTMLElement): void {
    // Try to load each logo option in order
    let currentIndex = 0;
    
    const tryNextLogo = () => {
      if (currentIndex >= options.length) {
        console.log('[DEBUG] All logo options failed, creating text fallback');
        this.createTextFallback(container);
        return;
      }
      
      const src = options[currentIndex].startsWith('data:') 
        ? options[currentIndex] 
        : this.urlResolver.resolveUrl(options[currentIndex]);
      
      console.log(`[DEBUG] Trying logo option ${currentIndex + 1}/${options.length}: ${src}`);
      
      const testImg = new Image();
      testImg.onload = () => {
        console.log(`[DEBUG] Logo option ${currentIndex + 1} loaded successfully`);
        logoElement.src = src;
      };
      
      testImg.onerror = () => {
        console.log(`[DEBUG] Logo option ${currentIndex + 1} failed to load`);
        currentIndex++;
        tryNextLogo();
      };
      
      testImg.src = src;
    };
    
    // Start the process
    tryNextLogo();
  }
  
  private createTextFallback(container: HTMLElement): void {
    try {
      // If we already have a logo element, clear it
      if (this.logoElement) {
        this.logoElement.style.display = 'none';
      }
      
      const fallbackLogo = document.createElement('div');
      fallbackLogo.className = 'onexip-text-logo';
      fallbackLogo.innerHTML = '<div style="font-size: 24px; font-weight: bold; color: #F97316;">onexip</div>';
      container.appendChild(fallbackLogo);
      console.log('[DEBUG] Fallback text logo added');
    } catch (e) {
      console.error('[ERROR] Even fallback logo failed:', e);
    }
  }
}
